<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento das Declarações Eletrônicas de Prestação de
                  Serviço para o Município.</span>
                <br />
                <span class="navigation">Nota Fiscal > Declaração</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <label style="font-weight: bold; font-size: 12px">Competência:</label>
          <div class="row">
            <div class="col-md-4 col-lg-2 mb-3">
              <InputText v-model="competencia" disabled />
            </div>
            <div>
              <Button @click="alterarCompetencia()" label="Alterar" type="button" class="p-button-primary mr-2"
                icon="pi pi-search" :disabled="loading" />
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <Button @click="showNotaDam()" alt="Pesquisar Por Nfse" label="Pesquisar Por Nfse" type="button"
                class="p-button-primary mr-2 p-button-success" icon="pi pi-search" :disabled="loading" />
              <label style="font-size: 12px" v-if="this.numeroNfsePesquisa">Filtro Nfse Número:
                {{ this.numeroNfsePesquisa }}</label>
              <label style="font-size: 12px" v-if="this.filtro">Filtro CPF/CNPJ/Nome Tomador:
                {{ this.filtro }}</label>
            </div>
          </div>

          <hr />

          <template v-if="!displayRetificar">
            <div class="pl-3 pr-3">
              <div class="pb-3" v-if="isPossuiTaxasDebito">
                <span style="font-weight: bold; color:red">
                  Uma ou mais declarações foram encerradas com débito para essa competência. Realize o pagamento da Taxa
                  gerada.
                </span>
              </div>

              <Panel :toggleable="false" header="Taxa" v-if="isPossuiTaxas">
                <div v-for="taxa in listTaxas" v-bind:key="taxa.id">
                  <hr v-if="taxa.id != listTaxas[0].id" />
                  <div class="row">
                    <div class="col-md-2 d-flex ml-2 align-items-center" v-if="isPossuiTaxasDebito">
                      <Button type="button" title="Imprimir Taxa" :label="!admin ? 'Imprimir' : ''"
                        class="p-button-primary mr-2" icon="pi pi-print" style="margin-right: 0.5em"
                        @click="imprimirBoletoTaxa(taxa)" :disabled="loading" />
                      <Button type="button" title="Cancelar Taxa" class="p-button-danger" icon="pi pi-times"
                        style="margin-right: 0.5em" @click="exibirCancelarTaxa(taxa)" :disabled="loading"
                        v-if="admin && taxa.idBolDebito === 'S'" />
                    </div>
                    <div class="col">
                      <div class="row">
                        <div class="col-sm mt-1 mb-1">
                          <b>Vencimento:</b>
                          {{ taxa.vencimentoFormatado }}
                        </div>
                        <div class="col-sm mt-1 mb-1">
                          <b>Pagamento:</b>
                          {{ taxa.pagamentoFormatado }}
                        </div>
                        <div class="col-sm-2 mt-1 mb-1">
                          <b>Valor:</b>
                          {{ taxa.valorFormatado }}
                        </div>
                        <div class="col-sm-2 mt-1 mb-1">
                          <b>Pago:</b>
                          {{ taxa.valorPagoFormatado }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Panel>
            </div>
            <hr v-if="isPossuiTaxas" />

            <div class="row pr-3 pl-3">
              <h4 class="panel-title">
                <span class="title">Declarações Geradas na Competência.</span>
              </h4>
              <DataTable :value="listDeclaracao" :paginator="true" :rows="10" class="p-datatable-responsive" :key="0"
                :autoLayout="true" style="min-width: 100%" :rowClass="rowClass" ref="dt1" :filters="filtersModel">
                <Column headerStyle="width: 1%">
                  <template #body="slotProps">
                    <div class="dropdown">
                      <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                        data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false" :disabled="slotProps.data.tipo === 'SIMPLIFICADA' && (!slotProps.data.dataEncerramento || slotProps.data.status === 'Cancelada')"></Button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="exportarExcel(slotProps.data.id)"
                          v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA'">
                          <span class="pi pi-file-excel mr-2" style="padding-right: 2vw"></span>Exportar Declaração
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="impressaoDeclaracao(slotProps.data.id)"
                          v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA'">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Impressão Declaração
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="impressaoProtocolo(slotProps.data.id)" v-if="apresentacao && slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA'">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Impressão Protocolo
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading" @click="
                          abrirDialogImpressao(
                            slotProps.data
                          )
                          " v-if="(slotProps.data.tipo === 'DAM_AVULSA' || slotProps.data.tipo === 'DAM_DEVEDOR_CONTUMAZ' || (slotProps.data.tipo === 'SIMPLIFICADA' && slotProps.data.dataEncerramento)) || (slotProps.data.tipo !== 'SIMPLIFICADA' && slotProps.data.dataEncerramento && !slotProps.data.dataVigenciaFinal && slotProps.data.semMovimento != 'Sim' && slotProps.data.idBolDebito === 'S')">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Impressão Boleto(s)
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="encerrarDeclaracao(slotProps.data.id)" v-if="!isBloqueado && slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                            !slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal
                          ">
                          <span class="pi pi-pencil mr-2" style="padding-right: 2vw"></span>Encerrar Declaração
                        </button>
                        <div class="dropdown-divider" v-if="!isBloqueado && slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                          !slotProps.data.dataEncerramento &&
                          !slotProps.data.dataVigenciaFinal
                        " />
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="carregarRetificacao(slotProps.data)" v-if="!isBloqueado && slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                            slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' && !fechamentoAutomatico &&
                            (slotProps.data.idBolDebito === 'S' || slotProps.data.idBolDebito === 'M')
                          ">
                          <span class="pi pi-replay mr-2" style="padding-right: 2vw"></span>{{ !isAnaliseRetificacao ?
                            'Retificar Declaração' : 'Cancelar Declaração' }}
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="cancelarDeclaracao(slotProps.data.id)" v-if="!isBloqueado && slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                            !slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal && !fechamentoAutomatico
                          ">
                          <span class="pi pi-times mr-2" style="padding-right: 2vw"></span>Cancelar
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="showDiaglogAplicarCredito(slotProps.data)" v-if="!isBloqueado && slotProps.data.tipo !== 'SIMPLIFICADA' && slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.semMovimento != 'Sim' &&
                            slotProps.data.idBolDebito === 'S' && habilitarCredito">
                          <span class="pi pi-money-bill mr-2" style="padding-right: 2vw"></span>Aplicar Crédito
                        </button>
                        <button class="dropdown-item" type="button"
                          v-show="!isBloqueado && currentUser.usuario.idBolAdmin && slotProps.data.situacao === 'Cancelada' && slotProps.data.idBolSemMovimento === 'S' && slotProps.data.tipo !== 'SIMPLIFICADA'"
                          :disabled="loading || inativo" @click="confirmaDesfazerCancelamento(slotProps.data.id)">
                          <span class="pi pi-pencil mr-2" style="padding-right: 2vw"></span>Desfazer Cancelamento
                          Declaração
                        </button>
                        <button class="dropdown-item" type="button"
                          v-show="!isBloqueado && slotProps.data.dataEncerramento && currentUser.usuario.idBolAdmin && slotProps.data.tipo !== 'SIMPLIFICADA'"
                          :disabled="loading || inativo" @click="openTransferirCalculoes(slotProps.data)">
                          <span class="pi pi-pencil mr-2" style="padding-right: 2vw"></span>Transferir Valores
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="openSuspensao(slotProps.data, 'S')" v-if="!isBloqueado && slotProps.data.dataEncerramento && currentUser.usuario.idBolAdmin &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' && !fechamentoAutomatico &&
                            (slotProps.data.idBolDebito === 'S' || slotProps.data.idBolDebito === 'M') && slotProps.data.tipo !== 'SIMPLIFICADA'
                          ">
                          <span class="pi pi-key mr-2" style="padding-right: 2vw"></span>Suspender Guia
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="openSuspensao(slotProps.data, 'C')" v-if="!isBloqueado && slotProps.data.dataEncerramento && currentUser.usuario.idBolAdmin &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' && !fechamentoAutomatico &&
                            (slotProps.data.situacao === 'Suspenso Processo') && slotProps.data.tipo !== 'SIMPLIFICADA'
                          ">
                          <span class="pi pi-lock-open mr-2" style="padding-right: 2vw"></span>Cancelar Suspenso
                          Processo
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="imprimirNotificacao(slotProps.data.id)" v-if="slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' &&
                            (slotProps.data.situacao === 'Notificado') && slotProps.data.tipo !== 'SIMPLIFICADA'
                          ">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Imprimir Notificação
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="imprimirAutoInfracao(slotProps.data.id)" v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                            slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' &&
                            (slotProps.data.situacao === 'Auto de Infração')
                          ">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Detalhes Auto de Infração
                        </button>

                      </div>
                    </div>

                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="id" header="Número">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.numero }}
                      <span v-if="slotProps.data.tipo === 'DAM_DEVEDOR_CONTUMAZ'" 
                        style="font-size: 10px; background-color: #007bff; color: white; padding: 1px 5px; border-radius: 3px; margin-left: 5px;">DAM Devedor Contumaz</span>
                      <span v-else-if="slotProps.data.tipo === 'DAM_AVULSA'" 
                        style="font-size: 10px; background-color: #007bff; color: white; padding: 1px 5px; border-radius: 3px; margin-left: 5px;">DAM Nota Avulsa</span>
                      <span v-else-if="slotProps.data.tipo === 'SIMPLIFICADA'" 
                        style="font-size: 10px; background-color: #007bff; color: white; padding: 1px 5px; border-radius: 3px; margin-left: 5px;">Declaração Simplificada</span>
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['numero']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 10em" />
                  </template>
                </Column>
                <Column headerStyle="width: 15%" field="idRetificado" header="Retificado">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{
                        slotProps.data.numeroRetificador
                          ? "Retificado pela Declaração nº " +
                          slotProps.data.numeroRetificador
                          : "-"
                      }}
                    </div>
                  </template>
                </Column>
                <Column headerStyle="width: 3%" field="dataFormatada" header="Data"
                  bodyStyle="padding: 0; text-align: center">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.dataFormatada }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['dataFormatada']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 5em" />
                  </template>
                </Column>
                <Column headerStyle="width: 5%" field="semMovimento" header="Sem Movimento?">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.semMovimento }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['semMovimento']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 5em" />
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="situacao" header="Status">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.situacao }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['situacao']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 10em" />
                  </template>
                </Column>
                <Column headerStyle="width: 5%" field="pago" header="Pago?">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.pago }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['pago']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 5em" />
                  </template>
                </Column>
                <Column headerStyle="width: 5%" field="dataPagamentoFormatada" header="Data Pagamento">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.dataPagamentoFormatada }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['dataPagamentoFormatada']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 5em" />
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="valor" header="Valor">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.valorFormatado }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['valor']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 10em" />
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="valorPago" header="Valor Pago">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.valorPagoFormatado }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['valorPago']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 10em" />
                  </template>
                </Column>
                <template #footer>
                  <div style="text-align: right">
                    <Button icon="pi pi-external-link" label="Exportar para CSV" @click="exportCSVDt1($event)" />
                  </div>
                </template>
              </DataTable>
            </div>
          </template>
          <template v-else>
            <div class="row">
              <div class="container-fluid">
                <div class="row">
                  <Card style="width: 100%">
                    <template slot="title">Declaração de Número
                      {{ this.declaracaoSelecionada.numero }} Selecionada para
                      retificação.</template>
                    <template slot="content">
                      Data: {{ this.declaracaoSelecionada.dataFormatada }}
                      <br />
                      Sem Movimento?
                      {{ this.declaracaoSelecionada.semMovimento }}
                      <br />
                    </template>
                  </Card>
                </div>
              </div>
              <div class="container-fluid">
                <div class="row">
                  <h4 class="panel-title" style="margin-top: 1px">
                    <span class="title">Notas Fiscais relacionadas a Declaração.</span>
                  </h4>
                </div>
              </div>
              <div class="container-fluid">
                <div class="row">
                  <Button type="button" title="Remover Todos" class="p-button-primary mr-2 p-button-danger"
                    icon="pi pi-times" style="margin-right: 0.5em" @click="removerNotasDeclaracao()" :disabled="loading"
                    label="Remover Todos"></Button>
                </div>
              </div>
              <div class="container-fluid" style="padding-top: 5px">
                <div class="row">
                  <DataTable id="teste" :value="listNotasDeclaradas" :paginator="true" :rows="10" :key="1"
                    :autoLayout="true" style="min-width: 100%" ref="dt2" :filters="filterModelNotasRet">
                    <Column headerStyle="width: 4em" header bodyStyle="text-align: center">
                      <template #body="slotProps">
                        <Button type="button" title="Remover" class="p-button-primary mr-2 p-button-danger"
                          icon="pi pi-times" style="margin-right: 0.5em" @click="removerNotaDeclaracao(slotProps.data)"
                          :disabled="loading"></Button>
                      </template>
                    </Column>
                    <Column headerStyle="width: 10%" field="numero" header="Numero" bodyStyle="text-align:right">
                      <template #filter>
                        <InputText type="text" v-model="filterModelNotasRet['numero']" class="p-column-filter"
                          placeholder="Iniciando com" />
                      </template>
                    </Column>
                    <Column headerStyle="width: 8em" field="dataEmissaoFormatada" header="Emissão"
                      bodyStyle="text-align:center">
                      <template #filter>
                        <InputText type="text" v-model="filterModelNotasRet['dataEmissaoFormatada']" class="p-column-filter"
                          placeholder="Iniciando com" style="width: 8em" />
                      </template>
                    </Column>
                    <Column headerStyle="width: 8em" field="dataGeracaoFormatada" header="Geração"
                      bodyStyle="text-align:center">
                      <template #filter>
                        <InputText type="text" v-model="filterModelNotasRet['dataGeracaoFormatada']" class="p-column-filter"
                          placeholder="Iniciando com" style="width: 8em" />
                      </template>
                        </Column>
                        <Column headerStyle="width: 10em" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
                        <template #filter>
                          <InputText type="text" v-model="filterModelNotasRet['valorFormatado']" class="p-column-filter"
                            placeholder="Iniciando com" style="width: 8em" />
                        </template>
                      </Column>
                    <Column field="tomador" header="Tomador">
                      <template #filter>
                        <InputText type="text" v-model="filterModelNotasRet['tomador']" class="p-column-filter"
                          placeholder="Iniciando com" />
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </template>
          <hr />
          <TabView>
            <TabPanel
              :header="displayRetificar ? 'Adicione abaixo novas notas a Declaração.' : 'Notas Fiscais em Aberto para realizar a Declaração.'">
              <template>
                <Checkbox v-model="checkTodos" :binary="true" @change="selecionarTodos()" v-if="!this.limitado" />
                <span style="padding-left: 5px; font-weight: bold; font-size: 12px" v-if="!this.limitado">Selecionar
                  Todos</span>
                <span style="padding-left: 5px; font-weight: bold; font-size: 12px;color:red" v-if="this.limitado">(O
                  Resultado abaixo foi limitado a 10 mil páginas, use a opção (Declarar Competência Geral) para declarar
                  por completo a competência.)</span>
              </template>
              <div style="padding-top: 10px">
                <DataTable :value="listNotas" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%"
                  ref="dt2" :filters="filtersModelNotas">
                  <Column headerStyle="width: 3%" field="selecionado" header v-if="!this.limitado">
                    <template #body="slotProps">
                      <Checkbox v-model="slotProps.data.selecionado" :binary="true" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 1%">
                    <template #body="slotProps">
                      <div class="dropdown">
                        <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                          data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <button class="dropdown-item" type="button" :disabled="loading"
                            v-if="slotProps.data.notaFiscal && slotProps.data.notaFiscal.transmitidoNacional === 'I'"
                            @click="visualizarDanfse(slotProps.data.id)">
                            <span class="pi pi-print mr-2"></span>DANFSE
                          </button>
                          <button class="dropdown-item" type="button" :disabled="loading"
                            v-if="!slotProps.data.notaFiscal || (slotProps.data.notaFiscal && slotProps.data.notaFiscal.transmitidoNacional !== 'I')"
                            @click="impressaoNota(slotProps.data.id)">
                            <span class="pi pi-print mr-2"></span>Imprimir
                          </button>
                        </div>
                      </div>
                    </template>
                  </Column>

                  <Column headerStyle="width: 10%" field="numero" header="Numero" bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotas['numero']" class="p-column-filter"
                        placeholder="Iniciando com" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 8em" field="dataEmissaoFormatada" header="Emissão"
                    bodyStyle="text-align:center">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotas['dataEmissaoFormatada']" class="p-column-filter"
                        placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 8em" field="dataGeracaoFormatada" header="Geração"
                    bodyStyle="text-align:center">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotas['dataGeracaoFormatada']" class="p-column-filter"
                        placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 10em" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotas['valorFormatado']" class="p-column-filter"
                        placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 10em" field="valorDeducaoFormatado" header="Dedução"
                    bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotas['valorDeducaoFormatado']"
                        class="p-column-filter" placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 8em" field="aliquota" header="Alíquota" bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotas['aliquota']" class="p-column-filter"
                        placeholder="Iniciando com" style="width: 5em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 10em" field="valorIssFormatado" header="Valor Iss"
                    bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotas['valorIssFormatado']" class="p-column-filter"
                        placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column field="tomador" header="Tomador">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotas['tomador']" class="p-column-filter"
                        placeholder="Iniciando com" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 6em" field="situacao" header="Situação" bodyStyle="text-align:center">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotas['situacao']" class="p-column-filter"
                        placeholder="Iniciando com" style="width: 6em" />
                    </template>
                  </Column>
                </DataTable>
              </div>
            </TabPanel>
            <TabPanel v-if="!fechamentoAutomatico && deducaoPlanoSaude"
              header="Notas Fiscais Recebidas para dedução na base de cálculo">
              <template>
                <Checkbox v-model="checkTodosDeducao" :binary="true" @change="selecionarTodosNotaDeducao()" />
                <span style="padding-left: 5px; font-weight: bold; font-size: 12px">Selecionar Todos</span>
              </template>
              <div style="padding-top: 10px">
                <DataTable :value="listNotasDeducao" :paginator="true" :rows="10" :autoLayout="true"
                  style="min-width: 100%" ref="dt3" :filters="filtersModelNotasDeducao">
                  <Column headerStyle="width: 3%" field="selecionado" header>
                    <template #body="slotProps">
                      <Checkbox v-model="slotProps.data.selecionado" :binary="true" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 1%">
                    <template #body="slotProps">
                      <div class="dropdown">
                        <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                          data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <button class="dropdown-item" type="button" :disabled="loading"
                            v-if="slotProps.data.notaFiscal && slotProps.data.notaFiscal.transmitidoNacional === 'I'"
                            @click="visualizarDanfse(slotProps.data.notaFiscal.id)">
                            <span class="pi pi-print mr-2"></span>DANFSE
                          </button>
                          <button class="dropdown-item" type="button" :disabled="loading"
                            v-if="!slotProps.data.notaFiscal || (slotProps.data.notaFiscal && slotProps.data.notaFiscal.transmitidoNacional !== 'I')"
                            @click="impressaoNota(slotProps.data.id)">
                            <span class="pi pi-print mr-2"></span>Imprimir
                          </button>
                        </div>
                      </div>
                    </template>
                  </Column>

                  <Column headerStyle="width: 10%" field="numero" header="Numero" bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotasDeducao['numero']" class="p-column-filter"
                        placeholder="Iniciando com" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 8em" field="dataEmissaoFormatada" header="Emissão"
                    bodyStyle="text-align:center">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotasDeducao['dataEmissaoFormatada']"
                        class="p-column-filter" placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 8em" field="dataGeracaoFormatada" header="Geração"
                    bodyStyle="text-align:center">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotasDeducao['dataGeracaoFormatada']"
                        class="p-column-filter" placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 10em" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotasDeducao['valorFormatado']"
                        class="p-column-filter" placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 10em" field="valorDeducaoFormatado" header="Dedução"
                    bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotasDeducao['valorDeducaoFormatado']"
                        class="p-column-filter" placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 8em" field="aliquota" header="Alíquota" bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotasDeducao['aliquota']" class="p-column-filter"
                        placeholder="Iniciando com" style="width: 5em" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 10em" field="valorIssFormatado" header="Valor Iss"
                    bodyStyle="text-align:right">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotasDeducao['valorIssFormatado']"
                        class="p-column-filter" placeholder="Iniciando com" style="width: 8em" />
                    </template>
                  </Column>
                  <Column field="tomador" header="Tomador">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotasDeducao['tomador']" class="p-column-filter"
                        placeholder="Iniciando com" />
                    </template>
                  </Column>
                  <Column headerStyle="width: 6em" field="situacao" header="Situação" bodyStyle="text-align:center">
                    <template #filter>
                      <InputText type="text" v-model="filtersModelNotasDeducao['situacao']" class="p-column-filter"
                        placeholder="Iniciando com" style="width: 6em" />
                    </template>
                  </Column>
                </DataTable>
              </div>
            </TabPanel>
          </TabView>
          <hr />
          <template v-if="!displayRetificar && this.limitado">
            <Button @click="declararCompetenciaGeral($event)" label="Declarar Competência Geral" type="button"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" v-if="!isBloqueado"/>
          </template>
          <template v-if="!displayRetificar">
            <Button @click="declarar($event)" label="Declarar" type="button"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading"
              v-if="!this.limitado && !isBloqueado" />
          </template>
          <template v-else>
            <Button @click="adicionarNotasDeclaracao()" label="Adicionar" type="button" class="p-button-primary mr-2"
              icon="pi pi-check" :disabled="loading" v-if="!isBloqueado"/>
            <hr />
            <Button @click="retificarDeclaracao()" label="Retificar Declaração" type="button"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-replay" :disabled="loading" v-if="!isBloqueado"/>
            <Button @click="hideRetificar()" label="Cancelar" type="button"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" :disabled="loading" v-if="!isBloqueado"/>
          </template>
          <template v-if="!displayRetificar && !fechamentoAutomatico && deducaoPlanoSaude">
            <router-link to="/CooperadoConsulta">
              <Button type="button" icon="pi pi-plus" label="Cadastrar Novo Cooperado"
                title="Cadastrar Novo Cooperado" />
            </router-link>
          </template>
        </div>
      </div>
    </div>
    <Dialog class="test-box" header="Justificar Retificação" :visible.sync="showRetificarDecAnalise" :modal="true"
      :closable="false" :style="{ width: '600px' }">
      <h1 class="titulo-header">
        Justificar Retificação
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showRetificarDecAnalise = false" />
      </h1><br />
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p>Informe o motivo de Retificação da Declaração.</p>
          </div>
        </div>
        <div id="topo" class="row">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">Observação: *</label>
            <span class="p-fluid">
              <textarea v-model="decAnalise.motivoRetificacao" rows="5" maxlength="500" />
            </span>
          </div>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button @click="saveMotivoRetifcacao()" href="#topo" type="button" label="Salvar"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          </div>
          <div>
            <Button @click="closeDialogRetifAnalise()" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Competência" :visible.sync="showSelectComp" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Competência
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showSelectComp = false" />
      </h1><br />
      <span class="p-fluid">
        <Dropdown id="filtroAno" v-model="filtroAno" :options="listAnos" optionLabel="name"
          placeholder="Selecione um Ano" />
      </span>
      <span class="p-fluid">
        <Dropdown id="filtroMes" v-model="filtroMes" :options="listMeses" optionLabel="name"
          placeholder="Selecione um Mês" />
      </span>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Selecionar" icon="pi pi-check" @click="pesquisar()" :disabled="loading" class="mr-2" />
            <Button label="Fechar" icon="pi pi-times" @click="fecharSelectCompetencia()" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Aviso" :visible.sync="displayDecSemMov" :style="{ width: '30vw' }" :modal="true">
      Confirma realizar a Declaração sem Movimento para Competência?
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="declararSemMovimento()" :disabled="loading" class="mr-2" />
            <Button label="Não" icon="pi pi-times" @click="hideDecSemMov()" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog
      :visible.sync="displayVencDamAvulso"
      :style="{ width: '42vw' }"
      :contentStyle="{ overflow: 'visible' }"
      :modal="true"
    >
      <h1 class="titulo-header">
        {{ tipoDamSelecionado === 'DAM_AVULSA' ? 'DAM Nota Avulsa' : 'DAM Devedor Contumaz' }}
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="displayVencDamAvulso = false"
        />
      </h1>
      <br />
      <div class="col-md-4 mb-8">
        <label for="dataVencDamAvulso">Data de Vencimento: *</label>
        <span class="p-fluid">
          <Calendar
            :key="keyVencDamAvulso"
            id="dataVencDamAvulso"
            name="dataVencDamAvulso"
            v-model="dataVencimento"
            :showIcon="true"
            dateFormat="dd/mm/yy"
          />
        </span>
      </div>
      <hr />
      <div>
        <div class="row ml-2 mb-2">
            <Button
              label="Imprimir Boleto"
              icon="pi pi-print"
              @click="imprimirBoletoDamAvulso()"
              :disabled="loading"
              class="mr-2"
            />
        </div>
        <div v-if="habilitarPix" class="row ml-2 mb-2">
            <Button
              type="button"
              label="Pagar com PIX"
              title="Pagar com PIX"
              class="p-button-outlined mr-2"
              icon="pi pix-icon"
              style="margin-right: 0.5em"
              :disabled="loading"
              @click="criarPagamentoPixDamAvulso()"
            ></Button>
            <Button
              label="Imprimir DAM PIX"
              class="p-button-outlined mr-2"
              icon="pi pix-icon"
              @click="imprimirBoletoPixDamAvulso()"
              :disabled="loading"
            />
            <Button
              title="Consultar Pagamento PIX"
              label="Consultar Pagamento PIX"
              icon="pi pi-search"
              style="margin-right: 0.5em"
              @click="consultarPagamentoPixDamAvulso()"
              class="mr-2"
            />
        </div>
        <div class="row ml-2 mt-3">
          <Button label="Fechar" icon="pi pi-times" @click="displayVencDamAvulso = false" class="p-button-secondary" />
        </div>
      </div>
    </Dialog>
    <Dialog header="Imprimir Boleto" :visible.sync="displayVencBoleto" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Imprimir Boleto
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayVencBoleto = false" />
      </h1><br />
      <div class="col-md-8 mb-8">
        <label for="dataVencBoleto">Data de Vencimento: *</label>
        <span class="p-fluid">
          <Calendar :disabled="disableDataVencDam" :key="keyVencBoleto" id="dataVencBoleto" name="dataVencBoleto"
            v-model="dataVencimento" :showIcon="true" dateFormat="dd/mm/yy" @date-select="vencimentoSelect()" />
        </span>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="imprimirBoleto()" v-if="tipoEmissaoBoleto === 'N'"
              :disabled="loading" class="mr-2" />
            <Button label="Sim" icon="pi pi-check" @click="imprimirBoletoPix()" v-if="tipoEmissaoBoleto === 'P'"
              :disabled="loading" class="mr-2" />
            <Button label="Não" icon="pi pi-times" @click="hideVencBoleto()" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Boleto" :visible.sync="displayBoletos" :style="{ width: '38vw' }" :modal="true">
      <h1 class="titulo-header">
        Boleto
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayBoletos = false" />
      </h1><br />

      <DataTable :value="listBoletos" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%">
        <Column headerStyle="width: 1em" header bodyStyle="text-align: center">
          <template #body="slotProps">
            <div class="d-flex align-items-center">
              <Button type="button" title="Imprimir Boleto" class="p-button-primary mr-2" icon="pi pi-print"
                style="margin-right: 0.5em" @click="
                  carregarVencimentoBoleto(
                    slotProps.data.id,
                    slotProps.data.tipo,
                    slotProps.data.dataVencimento,
                    'N'
                  )
                  " :disabled="loading" v-if="slotProps.data.pagamentoEfetuado == 'N'"></Button>
              <Button type="button" title="Pagar com PIX" class="p-button-outlined mr-2" icon="pi pix-icon"
                style="margin-right: 0.5em" @click="
                  escolhaPagamentoPix(
                    slotProps.data.id,
                    slotProps.data.tipo,
                    slotProps.data.dataVencimento
                  )
                  " :disabled="loading" v-if="slotProps.data.pagamentoEfetuado == 'N' && habilitarPix"></Button>
              <Button title="Consultar Pagamento PIX" icon="pi pi-search" style="margin-right: 0.5em"
                @click="consultarPagamentoPix(slotProps.data.id)" :disabled="loading"
                v-if="slotProps.data.pagamentoEfetuado == 'N' && habilitarPix" />
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 15%" field="vencimentoFormatado" header="Vencimento" bodyStyle="text-align:right">
        </Column>
        <Column field="valorFormatado" header="Valor" bodyStyle="text-align:center"></Column>
      </DataTable>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="hideBoletos()" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showEscolhaPix" :style="{ width: '30vw' }" :contentStyle="{ overflow: 'visible' }"
      :modal="true">
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="col-md-8 mb-8">
        <Button label="QR Code" icon="pi pi-bars" @click="criarPagamentoPix()" style="margin-right: 0.5em"
          :disabled="loading" />
        <Button label="Boleto" icon="pi pi-print" @click="
          carregarVencimentoBoleto(
            idDamAgrupamento,
            tipoDam,
            dataVencimento,
            'P'
          )
          " :disabled="loading" />
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="showEscolhaPix = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showPix" :style="{ width: '40vw' }" :modal="true">
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mb-2">
            <QRCanvas :options="optionsPix" />
          </div>
          <div class="col-md-6 mb-2">
            <div style="padding-top: 20px">
              Utilize o App de sua Instituição Financeira, na opção PIX escolha
              pagar com QR Code, confirme os dados e realize o Pagamento. <br />
              <br /><span style="font-weight: bold">Valor Total:
                {{ this.pixGerado ? this.pixGerado.valorFormatado : 0 }}</span>
            </div>
          </div>
        </div>
        <div class="row" v-if="this.pixGerado && this.pixGerado.linkQrcode">
          <div class="col-md-12 mb-2">
            <Button label="Copiar Código PIX" icon="pi pi-copy" @click="copiarPix()" />
          </div>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="showPix = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Aplicar desconto em Valores Declarados" :visible.sync="displayItensDecBeneficio"
      :style="{ width: '40vw' }" :modal="true">
      <h1 class="titulo-header">
        Aplicar desconto em Valores Declarados
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayItensDecBeneficio = false" />
      </h1><br />
      <DataTable :value="listItensDeclaracao" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%">
        <Column headerStyle="width: 8em" field="valorFormatado" header="Valor" bodyStyle="text-align:center"></Column>
        <Column headerStyle="width: 8em" field="aliquotaFormatado" header="Alíquota" bodyStyle="text-align:center">
        </Column>
        <Column headerStyle="width: 8em" field="abatimentoFormatado" header="Desconto" bodyStyle="text-align:center">
          <template #body="slotProps">
            <money id="abatimento" name="abatimento" v-model="slotProps.data.abatimento" v-bind="money"
              class="p-inputtext input-right"></money>
          </template>
        </Column>
        <Column headerStyle="width: 8em" field="valorIssFormatado" header="ISS" bodyStyle="text-align:center">
          <template #body="slotProps">
            {{
              getTotalIss(
                slotProps.data.valor,
                slotProps.data.abatimento,
                slotProps.data.aliquota
              )
            }}
          </template>
        </Column>
      </DataTable>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button @click="encerrarDeclaracaoBeneficio()" label="Encerrar Declaração" type="button"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
            <Button label="Fechar" icon="pi pi-times" @click="hideItensDecbeneficio()" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Pesquisar Declaração por Nfse" :visible.sync="showPesqNota" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Pesquisar Declaração por Nfse
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showPesqNota = false" />
      </h1><br />
      <span class="p-fluid">
        <InputText v-model="numeroNfsePesquisa" placeholder="Número Nfse" />
      </span>
      <span class="p-fluid">
        <InputText v-model="filtro" placeholder="CPF/CNPJ/Nome Tomador" />
      </span>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Pesquisar" icon="pi pi-check" @click="pesquisarPorNota()" :disabled="loading" class="mr-2" />
            <Button label="Fechar" icon="pi pi-times" @click="showPesqNota = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Aplicar Créditos" :visible.sync="showAplicarCredito" v-if="dadosCredito != null"
      :style="{ width: '30vw' }" :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Aplicar Créditos
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showAplicarCredito = false" />
      </h1><br />
      <div class="col-md-10 mb-8" v-if="dadosCredito.valorCreditoAplicado <= 0">
        <label style="font-weight: bold;">O município possibilita a aplicação do saldo de crédito abaixo até o
          percentual
          limite de: {{ dadosCredito.percentualLimiteAbatimentoCredito }}%. </label>
      </div>
      <div class="col-md-8 mb-8">
        <label for="dataVencBoleto">Declaracao Selecionada: </label>
        <span class="p-fluid" v-if="declaracaoSelecionada && declaracaoSelecionada.numero">
          <InputText v-model="declaracaoSelecionada.numero" disabled="true" />
        </span>
      </div>
      <div class="col-md-10 mb-8" v-if="dadosCredito.valorCreditoAplicado > 0">
        <label style="font-weight: bold;">Esta declaração ja possui um crédito aplicado no valor de: {{
          dadosCredito.valorCreditoAplicado }}, não é possível aplicar mais de um crédito. </label>
      </div>
      <div class="col-md-8 mb-8" v-if="dadosCredito.valorCreditoAplicado <= 0">
        <label for="dataVencBoleto">Saldo Crédito Disponível: </label>
        <span class="p-fluid">
          <InputText v-model="dadosCredito.saldoCredito" disabled="true" />
        </span>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Aplicar" icon="pi pi-check" @click="aplicarCredito()" :disabled="loading"
              v-if="dadosCredito.valorCreditoAplicado <= 0" class="mr-2" />
            <Button label="Fechar" icon="pi pi-times" @click="showAplicarCredito = false" :disabled="loading"
              class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Aviso" :visible.sync="displayAtivaDec" :style="{ width: '30vw' }" :modal="true">
      Confirma a reativação da declaração?
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="desfazerCancelamento()" class="mr-2" />
            <Button label="Não" icon="pi pi-times" @click="displayAtivaDec = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Cancelamento de Taxa" :visible.sync="displayCancelarTaxa" :style="{ width: '30vw' }" :modal="true">
      <h1 class="titulo-header">
        Cancelamento de Taxa
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayBoletos = false" />
      </h1><br />
      Informe o motivo do Cancelamento:
      <textarea v-model="motivoCancelamentoTaxa" rows="5" maxlength="500" />
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Confirmar" icon="pi pi-check" @click="cancelarTaxa()" class="mr-2" :disabled="loading" />
            <Button label="Voltar" icon="pi pi-times" @click="displayCancelarTaxa = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Transferência de Valores" :visible.sync="showTransfValores" :style="{ width: '30vw' }" :modal="true"
      v-if="declaracaoSelecionada">
      <h1 class="titulo-header">
        Transferência de Valores
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showTransfValores = false" />
      </h1><br />
      Declaração Selecionada: {{ declaracaoSelecionada.numero }}<br /><br />
      ATENÇÃO! Essa opção deve ser utilizada para transferir os calculos/valores da declaração selecionada para outra,
      nos casos onde há pagamento em declarações canceladas/retificadas e pagas.
      caso confirme a operação informe abaixo o numero de declaração de destino
      <hr />
      <span class="p-fluid">
        <InputText v-model="numeroDeclaracaoDestino" placeholder="Número Declaração Destino" />
      </span>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Transferir" icon="pi pi-check" @click="transferirCalculos()" class="mr-2" />
            <Button label="Fechar" icon="pi pi-times" @click="showTransfValores = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :header="estadoSuspensao === 'S' ? 'Suspender Guia' : 'Cancelar Suspenso Processo'"
      :visible.sync="showSuspensao" :style="{ width: '30vw' }" :modal="true"
      v-if="declaracaoSelecionada && estadoSuspensao">
      <h1 class="titulo-header">
        {{ estadoSuspensao === 'S' ? 'Suspender Guia' : 'Cancelar Suspenso Processo' }}
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showSuspensao = false" />
      </h1><br />
      Declaração Selecionada: {{ declaracaoSelecionada.numero }}<br /><br />
      Confirma {{ estadoSuspensao === 'S' ? 'a Suspenção da Guia' : 'o Cancelamento do Suspenso Processo' }}?
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="efetivarSuspensao()" class="mr-2" />
            <Button label="Fechar" icon="pi pi-times" @click="showSuspensao = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog 
      :visible.sync="showAutoInfracao"
      :style="{ width: '40vw' }"
      :modal="true"
    >
    <h1 class="titulo-header">Auto de Infração</h1>
    <hr/>
      <div style="padding: 1.5rem;">
        <small class="subtitle">Referente ao Auto de Infração de Número:</small>
        <div class="text-center mt-3">
          <input 
            v-model="dadosAutoInfracao"
            disabled
            class="p-inputtext custom-input"
          />
        </div>
        <hr class="custom-divider" style="margin: 1.5rem 0;" />
        <div class="flex justify-content-center">
          <Button 
            label="Fechar" 
            icon="pi pi-times" 
            @click="showAutoInfracao = false"
            class="p-button-danger"
          />
        </div>
      </div>
    </Dialog>
    <BlockUI :blocked="bloquearTela" fullScreen />
  </div>
</template>
<script>

import money from "../conf/config.money";
import NotaDeclaracaoComposicao from "../models/tributario/NotaDeclaracaoComposicao";
import RetificarDeclaracaoAnalise from "../models/tributario/RetificarDeclaracaoAnalise";
import DeclaracaoRetificacaoService from "../services/tributario/declaracao.retificacao.service";
import DeclaracaoService from "../services/tributario/declaracao.service";
import NotaFiscalService from "@/services/nfse/notafiscal.service";
import NotaFiscalAvulsaService from "../services/nfse/notafiscalavulsa.service";
import LoginService from "../services/acesso/login.service";
import ReportService from "../services/report.service";
import GpiService from "../services/nfse/gpi.service";
import { QRCanvas } from "qrcanvas-vue";
/* eslint-disable */
export default {
  name: "declaracaoNormal",
  components: {
    QRCanvas,
  },
  data() {
    return {
      money: money,
      apresentacao: false,
      keyVenc: 0,
      keyVencBoleto: 1,
      keyVencDamAvulso: 1,
      displayVencDamAvulso: false,
      tipoDamSelecionado: null,
      idNotaAvulsaSelecionada: null,
      filtersModel: {},
      filtersModelNotas: {},
      filtersModelNotasDeducao: {},
      filterModelNotasRet: {},
      competencia: "",
      inativo: false,
      checkTodos: false,
      checkTodosDeducao: false,
      loading: false,
      filtro: "",
      filtroAno: "",
      filtroMes: "",
      listAnos: [],
      listMeses: [],
      listDeclaracao: [],
      listItensDeclaracao: [],
      displayItensDecBeneficio: false,
      listNotas: [],
      listNotasDeducao: [],
      filters: {},
      currentUser: null,
      competenciaLimite: null,
      showSelectComp: false,
      displayDecSemMov: false,
      showImpressaoBoletos: false,
      idDeclaracaoSelecionada: null,
      dataVencimento: null,
      listNotasDeclaradas: [],
      declaracaoSelecionada: null,
      displayRetificar: false,
      displayBoletos: false,
      listBoletos: [],
      listTaxas: [],
      taxaSelecionada: null,
      motivoCancelamentoTaxa: null,
      displayCancelarTaxa: false,
      idDecLancamentoSelecionado: null,
      tipoDam: null,
      tipoEmissaoBoleto: "N",
      idDamAgrupamento: null,
      displayVencBoleto: false,
      habilitarPix: false,
      habilitarCredito: false,
      showEscolhaPix: false,
      showPix: false,
      optionsPix: {
        cellSize: 5,
        data: "hello",
      },
      pixGerado: null,
      numeroNfsePesquisa: '',
      showPesqNota: false,
      showRetificarDecAnalise: false,
      fechamentoAutomatico: false,
      decAnalise: new RetificarDeclaracaoAnalise(),
      dadosCredito: null,
      showAplicarCredito: false,
      deducaoPlanoSaude: false,
      displayAtivaDec: false,
      showTransfValores: false,
      showSuspensao: false,
      estadoSuspensao: null,
      numeroDeclaracaoDestino: null,
      boletos: false,
      admin: false,
      vencimentoAnterior: null,
      disableDataVencDam: false,
      travaDam: null,
      limitado: false,
      bloquearTela: false,
      showAutoInfracao: false,
      dadosAutoInfracao: null
    };
  },

  created() {
    this.apresentacao = (this.$apresentacao ? this.$apresentacao : false);
    this.competenciaLimite = new Date();
    this.competenciaLimite.setMonth(this.competenciaLimite.getMonth());
    this.currentUser = LoginService.currentUserValue;
    this.deducaoPlanoSaude = this.currentUser.contribuinte.deducaoPlanoSaudeNfse === 'S';
    if (this.deducaoPlanoSaude) {//empresas com deducao no plano de saude podem realizar o fechamento manual para aplicar o desconto
      this.fechamentoAutomatico = false;
    } else {
      this.fechamentoAutomatico = this.currentUser.configuracao.fechamentoAutomatico === 'S';
    }
    this.habilitarPix = this.currentUser.configuracao.idBolUtilizarPix === "S";
    this.habilitarCredito = this.currentUser.configuracao.idBolCreditoHabilitado === "S";
    this.inativo =
      this.currentUser && this.currentUser.contribuinte
        ? !this.currentUser.contribuinte.ativo
        : false;
    this.carregarAnos();
    this.carregarMeses();
    this.carregarCompetenciaAtual();
    this.pesquisar();
    this.admin = this.currentUser.usuario.idBolAdmin;
    this.travaDam = this.currentUser.configuracao.nfDiasTravaPagamentoBoleto;

  },

  methods: {
    openSuspensao(declaracao, estado) {
      this.declaracaoSelecionada = declaracao;
      this.estadoSuspensao = estado;
      this.showSuspensao = true;
    },
    efetivarSuspensao() {
      this.processando(true);
      if (this.estadoSuspensao === 'S') {
        DeclaracaoService.suspenderGuia(
          this.currentUser.usuario.idUsuario,
          this.declaracaoSelecionada.id
        )
          .then((response) => {
            console.log(response);
            this.pesquisar();
            this.showSuspensao = false;
            this.$root.$emit(
              "alert:success",
              "Suspensão de Guia realizada com sucesso!"
            );
          },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        DeclaracaoService.cancelarSuspencaoGuia(
          this.currentUser.usuario.idUsuario,
          this.declaracaoSelecionada.id
        )
          .then((response) => {
            console.log(response);
            this.pesquisar();
            this.showSuspensao = false;
            this.$root.$emit(
              "alert:success",
              "Cancelamento Suspenso Processo realizado com sucesso!"
            );
          },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    async openTransferirCalculoes(declaracao) {
      this.declaracaoSelecionada = declaracao;
      this.idDeclaracaoSelecionada = declaracao.id;
      this.showTransfValores = true;
      this.numeroDeclaracaoDestino = null;
    },
    transferirCalculos() {
      this.processando(true);
      DeclaracaoService.transferirCalculosDeclaracao(
        this.idDeclaracaoSelecionada,
        this.numeroDeclaracaoDestino
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.showTransfValores = false;
          this.$root.$emit(
            "alert:success",
            "Transferência realizada com sucesso!"
          );
        },
          (error) => {
            console.log(error);
            this.$root.$emit("alert:warn", error.response.data);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    vencimentoSelect() {
      let dateSelect = this.dataVencimento;
      if (dateSelect) {
        dateSelect.setHours(8);
      }
    },
    copiarPix() {
      navigator.clipboard.writeText(this.pixGerado.linkQrcode);
    },
    rowClass(data) {
      if (data.tipo === "DAM_AVULSA" || data.tipo === "DAM_DEVEDOR_CONTUMAZ") {
        return data.pago !== "Sim" ? "green-row" : null;
      }
      return data.status === "Cancelada" || data.status === "Retificada"
        ? "red-row"
        : data.status === "Encerrada"
          ? "green-row"
          : null;
    },
    lineClass(data) {
      if (data.tipo === "DAM_AVULSA" || data.tipo === "DAM_DEVEDOR_CONTUMAZ") {
        return data.pago !== "Sim" ? "white-line" : null;
      }
      return data.status === "Cancelada" ||
        data.status === "Retificada" ||
        data.status === "Encerrada"
        ? "white-line"
        : null;
    },
    rolarPagina() {
      document.getElementById("topo").scrollIntoView({
        behavior: "smooth",
      });
    },
    alterarCompetencia() {
      this.showSelectComp = true;
    },
    fecharSelectCompetencia() {
      this.showSelectComp = false;
    },
    pesquisarPorNota() {
      if (this.numeroNfsePesquisa.trim() === '' && this.filtro.trim() === '') {
        this.showPesqNota = false;
        this.pesquisar();
        return;
      }
      this.processando(true);

      let novaCompetencia =
        this.filtroAno.key +
        "" +
        this.formatted_string("00", this.filtroMes.key, "l");
      let compMax =
        this.competenciaLimite.getFullYear() +
        "" +
        this.formatted_string("00", this.competenciaLimite.getMonth() + 1, "l");

      if (parseInt(novaCompetencia) > parseInt(compMax)) {
        this.$root.$emit("alert:warn", "Competência ainda não disponivel!");
        this.processando(false);
        return;
      }

      this.competencia = this.filtroMes.name + "/" + this.filtroAno.key;
      DeclaracaoService.findAllDeclaracoesNumero(
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key,
        this.numeroNfsePesquisa,
        this.filtro
      ).then((response) => {
        this.listDeclaracao = response.data;
        console.log("Lista de Declarações:")
        console.log(this.listDeclaracao);
      }).then(() => {
        this.showPesqNota = false;
        this.processando(false);
      });
    },
    async pesquisar() {
      this.processando(true);

      let novaCompetencia =
        this.filtroAno.key +
        "" +
        this.formatted_string("00", this.filtroMes.key, "l");
      let compMax =
        this.competenciaLimite.getFullYear() +
        "" +
        this.formatted_string("00", this.competenciaLimite.getMonth() + 1, "l");

      if (parseInt(novaCompetencia) > parseInt(compMax)) {
        this.$root.$emit("alert:warn", "Competência ainda não disponivel!");
        this.processando(false);
        return;
      }

      this.competencia = this.filtroMes.name + "/" + this.filtroAno.key;

      await this.carregarNotasEmAberto();
      await this.carregarNotasDeducao();
      await this.carregarDeclaracoes();
      await this.carregarTaxas();

      this.showSelectComp = false;
      this.processando(false);
    },
    async carregarNotasEmAberto() {
      this.limitado = false;
      return DeclaracaoService.findAllNotasEmAberto(
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key
      )
        .then((responseNota) => {
          this.listNotas = responseNota.data;
          if (this.listNotas.length > 0 && this.listNotas[0].limitado === true) {
            this.limitado = true;
          }
        })
    },
    async carregarNotasDeducao() {
      this.listNotasDeducao = [];
      if (this.deducaoPlanoSaude) {
        return DeclaracaoService.findAllNotasDeducao(
          this.currentUser.contribuinte.documento,
          this.currentUser.contribuinte.idContribuinte,
          this.filtroAno.key,
          this.filtroMes.key
        )
          .then((responseNota) => {
            this.listNotasDeducao = responseNota.data;
          })
      }
    },
    async carregarDeclaracoes() {
      return DeclaracaoService.findAllDeclaracoes(
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key
      ).then((response) => {
        this.listDeclaracao = response.data;
        console.log(this.listDeclaracao);
      })
    },
    processando(show, block = false) {
      if (show) {
        this.loading = true;
        this.bloquearTela = block;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.bloquearTela = false;
        this.$root.$emit("loading:hide");
      }
    },
    carregarItensBeneficio(idDeclaracao) {
      DeclaracaoService.findAllItensDeclaracao(idDeclaracao).then(
        (response) => {
          this.listItensDeclaracao = response.data;
          this.displayItensDecBeneficio = true;
        }
      );
    },
    carregarAnos() {
      let ano = this.competenciaLimite.getFullYear();
      // eslint-disable-next-line
      for (var i = ano; i > ano - 16; i--) {
        this.listAnos.push({ name: i, key: i });
      }
    },
    carregarMeses() {
      this.listMeses.push({ name: "Janeiro", key: 1 });
      this.listMeses.push({ name: "Fevereiro", key: 2 });
      this.listMeses.push({ name: "Março", key: 3 });
      this.listMeses.push({ name: "Abril", key: 4 });
      this.listMeses.push({ name: "Maio", key: 5 });
      this.listMeses.push({ name: "Junho", key: 6 });
      this.listMeses.push({ name: "Julho", key: 7 });
      this.listMeses.push({ name: "Agosto", key: 8 });
      this.listMeses.push({ name: "Setembro", key: 9 });
      this.listMeses.push({ name: "Outubro", key: 10 });
      this.listMeses.push({ name: "Novembro", key: 11 });
      this.listMeses.push({ name: "Dezembro", key: 12 });
    },
    carregarCompetenciaAtual() {
      let ano = this.competenciaLimite.getFullYear();
      let mes = this.competenciaLimite.getMonth();
      mes = mes + 1;

      //Três Corações usa a competência anterior da atual como tela inicial
      if (this.currentUser.usuario.idCliente === 'F58DEFAB039A9DB0F91C6B13F7C32A46') {
        mes = mes - 1;
        if (mes < 1) {
          mes = 12;
          ano = ano - 1;
        }
      }

      this.filtroAno = this.listAnos.filter((local) => local.key == ano)[0];
      this.filtroMes = this.listMeses.filter((local) => local.key == mes)[0];
      this.competencia = this.filtroMes.name + "/" + ano;
    },
    selecionarTodos() {
      if (this.checkTodos) {
        this.listNotas.forEach(function (value) {
          value.selecionado = true;
        });
      } else {
        this.listNotas.forEach(function (value) {
          value.selecionado = false;
        });
      }
    },
    selecionarTodosNotaDeducao() {
      if (this.checkTodosDeducao) {
        this.listNotasDeducao.forEach(function (value) {
          value.selecionado = true;
        });
      } else {
        this.listNotasDeducao.forEach(function (value) {
          value.selecionado = false;
        });
      }
    },
    declarar(event) {
      //solução feita para evitar duplo click e o evento acontecer 2 vezes causando problemas de duplicidade de declaração
      if (!event.detail || event.detail == 1) {
        this.processando(true, true);
        if (
          (!this.listNotas || this.listNotas.length <= 0) &&
          (!this.listDeclaracao || this.listDeclaracao.length <= 0)
        ) {
          this.confirmaDeclararSemMovimento();
          return;
        }
        let checked = false;
        this.listNotas.forEach(function (value) {
          if (value.selecionado) {
            checked = true;
            return;
          }
        });
        if (!checked) {
          this.$root.$emit(
            "alert:warn",
            "Selecione ao menos uma nota para realizar a Declaração!"
          );
          this.processando(false);
        } else {
          this.declararNotas();
        }
      }
    },
    confirmaDeclararSemMovimento() {
      this.processando(false);
      this.displayDecSemMov = true;
    },
    hideDecSemMov() {
      this.displayDecSemMov = false;
    },
    declararSemMovimento() {
      DeclaracaoService.declararSemMov(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key
      ).then((response) => {
        console.log(response);
        this.pesquisar();
        this.$root.$emit(
          "alert:success",
          "Declaração sem Movimento gerada com sucesso!"
        );
      });
      this.displayDecSemMov = false;
    },
    declararNotas() {
      let listNotasSelecionadas = [];
      let listNotasDeducaoSelecionadas = [];
      this.listNotas.forEach(function (value) {
        if (value.selecionado) {
          value.dataPagamento = value.dataPagamentoFormatada;
          listNotasSelecionadas.push(value);
        }
      });
      this.listNotasDeducao.forEach(function (value) {
        if (value.selecionado) {
          listNotasDeducaoSelecionadas.push(value);
        }
      });

      let composicaoNotas = new NotaDeclaracaoComposicao();
      composicaoNotas.notasFiscais = listNotasSelecionadas;
      composicaoNotas.notasFiscaisDeducao = listNotasDeducaoSelecionadas;

      this.rolarPagina();

      DeclaracaoService.declarar(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key,
        "N",
        composicaoNotas
      )
        .then(
          (response) => {
            console.log(response);
            this.pesquisar();
            this.$root.$emit("alert:success", "Declaração gerada com sucesso!");
          },
          (error) => {
            console.log(error);
            let errorMessage = "Houve um problema ao gerar a Declaração!";

            if (error.response) {
              const errors = Array.isArray(error.response.data)
                ? error.response.data
                : [error.response.data];

              errors.forEach(err => {
                this.$toast.add({
                  severity: "error",
                  summary: "Erro",
                  detail: err,
                  life: 5000
                });
              });
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: errorMessage,
                life: 5000
              });
            }
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    declararCompetenciaGeral(event) {
      //solução feita para evitar duplo click e o evento acontecer 2 vezes causando problemas de duplicidade de declaração
      if (!event.detail || event.detail == 1) {
        this.processando(true);
        DeclaracaoService.declararCompetenciaGeral(
          this.currentUser.usuario.idCliente,
          this.currentUser.usuario.idUsuario,
          this.currentUser.contribuinte.idContribuinte,
          this.filtroAno.key,
          this.filtroMes.key
        )
          .then(
            (response) => {
              console.log(response);
              this.pesquisar();
              this.$root.$emit("alert:success", "Declaração gerada com sucesso!");
            },
            (error) => {
              console.log(error);
              let errorMessage = "Houve um problema ao gerar a Declaração!";

              if (error.response) {
                const errors = Array.isArray(error.response.data)
                  ? error.response.data
                  : [error.response.data];

                errors.forEach(err => {
                  this.$toast.add({
                    severity: "error",
                    summary: "Erro",
                    detail: err,
                    life: 5000
                  });
                });
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Erro",
                  detail: errorMessage,
                  life: 5000
                });
              }
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    confirmaDesfazerCancelamento(id) {
      this.declaracaoId = id;
      this.displayAtivaDec = true;
    },
    desfazerCancelamento() {
      if (this.declaracaoId) {
        this.processando(true);

        DeclaracaoService.desfazerCancelamento(this.declaracaoId)
          .then((response) => {
            console.log(response);
            this.pesquisar();
            this.displayAtivaDec = false;
            this.$root.$emit("alert:success", "Declaração reativada com sucesso!");
          },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao reativar declaração!");
              console.log(error);
            })
          .then(() => {
            this.processando(false);
          });
      }
    },
    cancelarDeclaracao(idDeclaracao) {
      this.processando(true);
      DeclaracaoService.cancelar(
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        idDeclaracao
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.$root.$emit(
            "alert:success",
            "Declaração cancelada com sucesso!"
          );
        })
        .then(() => {
          this.processando(false);
        });
    },
    async carregarDadosCredito(idDeclaracao) {
      return DeclaracaoService.carregarDadosCredito(
        this.currentUser.usuario.idUsuario,
        idDeclaracao
      )
        .then((response) => {
          console.log(response);
          this.dadosCredito = response.data;
        },
          (error) => {
            console.log(error);
            this.$root.$emit("alert:warn", error.response.data);
          }
        )

    },
    async showDiaglogAplicarCredito(declaracao) {
      this.processando(true);
      this.dadosCredito = null;
      this.declaracaoSelecionada = declaracao;
      await this.carregarDadosCredito(declaracao.id);
      let possuiSaldo = false;
      if (this.dadosCredito != null && this.dadosCredito.saldoCredito && this.dadosCredito.saldoCredito > 0) {
        possuiSaldo = true
      }
      if (!possuiSaldo) {
        this.$root.$emit("alert:warn", "Contribuinte não possui crédito disponivel para aplicar!");
        this.processando(false);
        return;
      }
      this.showAplicarCredito = true;
      this.processando(false);

    },
    aplicarCredito() {
      this.processando(true);
      DeclaracaoService.aplicarCredito(
        this.currentUser.usuario.idUsuario,
        this.declaracaoSelecionada.id
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.showAplicarCredito = false;
          this.$root.$emit(
            "alert:success",
            "Crédito aplicado com sucesso!"
          );
        },
          (error) => {
            console.log(error);
            this.$root.$emit("alert:warn", error.response.data);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    encerrarDeclaracaoBeneficio() {
      this.processando(true);
      DeclaracaoService.encerrarComBeneficio(
        this.currentUser.usuario.idUsuario,
        this.listItensDeclaracao
      )
        .then(
          (response) => {
            console.log(response);
            this.pesquisar();
            this.$root.$emit(
              "alert:success",
              "Declaração encerrada com sucesso!"
            );
          },
          (error) => {
            console.log(error);
            this.$root.$emit("alert:error", error.response.data);
          }
        )
        .then(() => {
          this.displayItensDecBeneficio = false;
          this.processando(false);
        });
    },
    encerrarDeclaracao(id) {
      this.idDeclaracaoSelecionada = id;
      this.processando(true);
      DeclaracaoService.encerrar(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.idDeclaracaoSelecionada
      )
        .then(
          (response) => {
            console.log(response);
            if (response.data === "BG") {
              this.carregarItensBeneficio(this.idDeclaracaoSelecionada);
            } else {
              this.pesquisar();
              this.$root.$emit(
                "alert:success",
                "Declaração encerrada com sucesso!"
              );
            }
          },
          (error) => {
            console.log(error);
            let erro = "Não foi possível encerrar a Declaração, verifique com o administrador do sistema se o Serviço de Geração de DAM esta disponível!";
            if (error.response && error.response.data) {
              erro = error.response.data;
            }
            this.$root.$emit(
              "alert:error",
              erro
            );
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    async carregarRetificacao(declaracao) {
      this.declaracaoSelecionada = declaracao;

      this.dadosCredito = null;
      await this.carregarDadosCredito(declaracao.id);
      if (this.dadosCredito != null && this.dadosCredito.valorCreditoAplicado && this.dadosCredito.valorCreditoAplicado > 0) {
        this.$root.$emit(
          "alert:warn",
          "Não será possível Retificar a declaração, pois foi aplicado um valor de crédito!"
        );
        return;
      }

      this.processando(true);
      DeclaracaoRetificacaoService.validarDeclaracao(this.declaracaoSelecionada.id)
        .then((responseValidacao) => {
          const erros = responseValidacao.data;
          if (erros.length > 0) {
            this.$root.$emit("alert:warn", erros[0]);
            return;
          }

          DeclaracaoService.competenciaEmFiscalizacao(this.declaracaoSelecionada.id)
            .then((responseFisc) => {
              console.log(responseFisc);
              let comp = this.declaracaoSelecionada.ano + '/' + this.declaracaoSelecionada.mes;
              if (responseFisc.data === 'S') {
                this.$root.$emit(
                  "alert:warn",
                  "Não sera possível Retificar a declaração, Contribuinte em processo de Fiscalização para o período: " + comp + " !"
                );
                return;
              }

              if (this.isAnaliseRetificacao) {
                this.showDialogRetifAnalise()
              } else {
                DeclaracaoService.carregarNotasDeclaracao(this.declaracaoSelecionada.id)
                  .then((response) => {
                    console.log(response);
                    this.listNotasDeclaradas = response.data;
                    this.displayRetificar = true;
                  })
              }
            })
        })
        .then(() => {
          this.processando(false);
        });
    },
    hideRetificar() {
      this.processando(true);
      this.declaracaoSelecionada = null;
      this.displayRetificar = false;
      this.pesquisar();
      this.rolarPagina();
      this.processando(false);
    },
    adicionarNotasDeclaracao() {
      this.processando(true);
      for (let i = this.listNotas.length - 1; i >= 0; i--) {
        if (this.listNotas[i].selecionado) {
          this.listNotasDeclaradas.push(this.listNotas[i]);
          this.listNotas.splice(i, 1);
        }
      }
      this.listNotasDeclaradas.sort(function (a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    removerNotaDeclaracao(notaDec) {
      this.processando(true);
      notaDec.selecionado = false;
      this.listNotas.push(notaDec);
      this.listNotasDeclaradas.forEach(function (item, index, object) {
        if (item.id === notaDec.id) {
          object.splice(index, 1);
        }
      });
      this.listNotas.sort(function (a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    removerNotasDeclaracao() {
      this.processando(true);
      let newList = this.listNotas.slice();
      this.listNotasDeclaradas.forEach(function (item) {
        newList.push(item);
      });
      this.listNotas = newList;
      this.listNotasDeclaradas = [];
      this.listNotas.sort(function (a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    retificarDeclaracao() {
      this.processando(true);
      DeclaracaoService.retificar(
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.currentUser.usuario.idCliente,
        this.declaracaoSelecionada.id,
        this.listNotasDeclaradas
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.$root.$emit(
            "alert:success",
            "Declaração retificada com sucesso!"
          );
          this.hideRetificar();
        },
          (error) => {
            console.log(error);
            let erro = "";
            if (error.response && error.response.data) {
              erro = error.response.data;
            }
            this.$root.$emit(
              "alert:error",
              erro
            );
          })
        .then(() => {
          this.processando(false);
        });
    },
    showDialogRetifAnalise() {
      this.showRetificarDecAnalise = true;
    },
    closeDialogRetifAnalise() {
      this.limparDadosDecAnalise();
      this.showRetificarDecAnalise = false;
    },
    imprimirAutoInfracao(idDeclaracao){
      DeclaracaoService.obterDadosAutoInfracao(idDeclaracao).then(
        data =>{
          this.dadosAutoInfracao = data.data;
          console.log(data);
        },
        error => {
          console.log(error);
        }
      )
      this.showAutoInfracao = true;
    },
    limparDadosDecAnalise() {
      this.decAnalise.motivoRetificacao = '';
    },
    saveMotivoRetifcacao() {
      this.decAnalise.idDeclaracao = this.declaracaoSelecionada.id;
      this.decAnalise.idContribuinte = this.currentUser.contribuinte.idContribuinte;

      DeclaracaoRetificacaoService.retificarDeclaracaoAnalise(this.decAnalise).then(
        data => {
          console.log(data);
          this.$root.$emit(
            "alert:success",
            "Solicitação de Retificação enviada com sucesso!"
          );
          this.closeDialogRetifAnalise();
        },
        error => {
          console.log(error);
          this.$root.$emit(
            "alert:error",
            error.response.data
          );
        }
      );
    },
    exportarExcel(id) {
      var idDeclaracao = id;
      this.exportarDeclaracaoTipo('xls', idDeclaracao);
    },
    exportarDeclaracaoTipo(tipo, idDeclaracao) {
      this.processando(true);
      ReportService.imprimir("DeclaracaoMensalServicosXls", [
        {
          param: "ID",
          string: idDeclaracao,
        },
        {
          param: "TIPO",
          string: "N",
        },
      ], tipo)
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao Imprimir!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    impressaoDeclaracao(id) {
      this.processando(true);
      ReportService.imprimir("DeclaracaoMensalServicos", [
        {
          param: "ID",
          string: id,
        },
        {
          param: "TIPO",
          string: "N",
        },
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit(
              "alert:warn",
              "Erro ao imprimir Detalhamento Declaração!"
            );
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    impressaoProtocolo(id) {
      this.processando(true);
      ReportService.imprimir("nfs_protocolo_declaracao", [
        {
          param: "ID",
          string: id,
        }
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit(
              "alert:warn",
              "Erro ao imprimir Detalhamento Declaração!"
            );
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    abrirDialogImpressao(data) {
      if (data.tipo === 'DAM_AVULSA' || data.tipo === 'DAM_DEVEDOR_CONTUMAZ') {
        if (data.pago === 'Sim' && !this.currentUser.usuario.idBolAdmin) {
          this.$root.$emit('alert:warn', 'Não é possível imprimir um Boleto Pago!');
          return;
        }
        this.idNotaAvulsaSelecionada = data.id.replace('DAM_', '');
        this.tipoDamSelecionado = data.tipo;
        
        let novaData = new Date();
        this.dataVencimento = novaData;
        this.displayVencDamAvulso = true;
      } else {
        this.impressaoBoletos(data.id, data.pago);
      }
    },
    imprimirBoletoDamAvulso() {
      if (!this.dataVencimento) {
        this.$root.$emit('alert:warn', 'Data de Vencimento Obrigatória!');
        return;
      }
      this.processando(true);
      NotaFiscalAvulsaService.atualizarVencimento(this.idNotaAvulsaSelecionada, this.dataVencimento)
        .then(
          (response) => {
            let idGerado = response.data;
            ReportService.imprimir('trb_dam_a5', [
              {
                param: 'RP_ID_CLIENTE',
                string: this.currentUser.usuario.idCliente,
              },
              {
                param: 'P_CONTROLE_PARCELA',
                string: " and cp.id_situacao in('1','4','6')  and  cp.id in ('" + idGerado + "')",
              },
            ]).then(
              () => {
                this.processando(false);
              },
              (error) => {
                this.processando(false);
                this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
                console.log(error);
              },
            );
          },
          (error) => {
            this.processando(false);
            this.$root.$emit('alert:warn', 'Erro ao atualizar Vencimento!');
            console.log(error);
          },
        )
    },
    criarPagamentoPixDamAvulso() {
      this.processando(true);
      NotaFiscalAvulsaService.criarPagamentoPix(this.idNotaAvulsaSelecionada).then(
        (response) => {
          this.pixGerado = response.data;
          this.showPix = true;
          this.processando(false);
        },
        (error) => {
          this.processando(false);
          this.$root.$emit('alert:warn', 'Erro ao gerar PIX!');
          console.log(error);
        }
      );
    },
    imprimirBoletoPixDamAvulso() {
      if (!this.dataVencimento) {
        this.$root.$emit('alert:warn', 'Data de Vencimento Obrigatória!');
        return;
      }
      this.processando(true);
      NotaFiscalAvulsaService.atualizarVencimento(this.idNotaAvulsaSelecionada, this.dataVencimento)
        .then(
          (response) => {
            let idGerado = response.data;
            NotaFiscalAvulsaService.criarPagamentoPixCp(this.idNotaAvulsaSelecionada, idGerado).then(
              (response) => {
                this.pixGerado = response.data;
                ReportService.imprimir('trb_dam_a5_pix', [
                  {
                    param: 'RP_ID_CLIENTE',
                    string: this.currentUser.usuario.idCliente,
                  },
                  {
                      param: 'QR_CODE',
                      string: this.pixGerado.qrCode,
                    },
                  {
                    param: 'P_CONTROLE_PARCELA',
                    string: " and cp.id_situacao in('1','4','6')  and  cp.id in ('" + idGerado + "')",
                  },
                ]).then(
                  () => {
                    this.processando(false);
                  },
                  (error) => {
                    this.processando(false);
                    this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
                    console.log(error);
                  },
                );
              },
              (error) => {
                this.processando(false);
                this.$root.$emit('alert:warn', 'Erro ao processar PIX!');
                console.log(error);
              }
            );
          },
          (error) => {
            this.processando(false);
            this.$root.$emit('alert:warn', 'Erro ao atualizar Vencimento!');
            console.log(error);
          },
        );
    },
    consultarPagamentoPixDamAvulso() {
      this.processando(true);
      NotaFiscalAvulsaService.consultarPagamentoPix(this.idNotaAvulsaSelecionada).then(
        (response) => {
          let retorno = response.data;
          if (retorno) {
            this.$root.$emit('alert:sucess', 'Pagamento recebido!');
          } else {
            this.$root.$emit('alert:warn', 'Pagamento não recebido!');
          }
          this.processando(false);
        },
        (error) => {
          this.processando(false);
          this.$root.$emit('alert:warn', 'Erro ao consultar PIX!');
          console.log(error);
        }
      );
    },
    impressaoBoletos(id, pago) {
      console.log(pago);
      this.processando(true);
      this.idDeclaracaoSelecionada = id;
      DeclaracaoService.competenciaEmFiscalizacao(this.idDeclaracaoSelecionada)
        .then((responseFisc) => {
          console.log(responseFisc);
          if (responseFisc.data === 'S') {
            this.$root.$emit(
              "alert:warn",
              "Não sera possível a Imppressão do Boleto, Contribuinte em processo de Fiscalização para o período da declaração!"
            );
            this.processando(false);
            return;
          }
          DeclaracaoService.findBoletos(id)
            .then((response) => {
              this.listBoletos = response.data;

              this.boletos = this.listBoletos.find(boleto => {
                return boleto;
              });

              this.vencimentoMaximo = new Date(this.boletos.vencimentoAnterior);
              //por problemas com a data vinda do backend tranformando em Date js vai ser incluido 1 dia pois o seDate esta retirando 1 dia ao transformar a data
              this.vencimentoMaximo.setDate(this.vencimentoMaximo.getDate() + 1);
              if (this.travaDam > 0) {
                this.vencimentoMaximo.setDate(this.vencimentoMaximo.getDate() + this.travaDam);
              }
            })
            .then(() => {
              this.showImpressaoBoletos = true;

              this.displayBoletos = true;
              this.processando(false);
            });
        })
    },
    impressaoBoletosDam(declaracao) {
      this.processando(true);
      // Extrair o id_nota_fiscal removendo o prefixo 'DAM_'
      let idNotaAvulsa = declaracao.id.replace('DAM_', '');
      let dataVencimento = new Date();

      NotaFiscalAvulsaService.atualizarVencimento(idNotaAvulsa, dataVencimento)
        .then(
          (response) => {
            let idGerado = response.data;
            ReportService.imprimir('trb_dam_a5', [
              {
                param: 'RP_ID_CLIENTE',
                string: this.currentUser.usuario.idCliente,
              },
              {
                param: 'P_CONTROLE_PARCELA',
                string: " and cp.id_situacao in('1','4','6')  and  cp.id in ('" + idGerado + "')",
              },
            ]).then(
              () => {},
              (error) => {
                this.$root.$emit('alert:warn', 'Erro ao exibir a visualização do DAM!');
                console.log(error);
              }
            );
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao preparar a impressão do DAM!');
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    hideBoletos() {
      this.displayBoletos = false;
    },
    async imprimirBoletoTaxa(taxa) {
      this.processando(true);
      await GpiService.imprimirTaxa(taxa.idCliente, taxa.ano, taxa.numero).then(
        (data) => {
          console.log(data);
        },
        (error) => {
          this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
          console.log(error);
        }
      ).then(() => {
        this.displayBoletos = false;
        this.processando(false);
      });
    },
    cancelarTaxa() {
      if (!this.motivoCancelamentoTaxa) {
        this.$root.$emit("alert:warn", "Informe o motivo da cancelamento!")
        return;
      }

      this.processando(true);
      DeclaracaoService.cancelarTaxa(
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.taxaSelecionada.idCliente,
        this.taxaSelecionada.ano,
        this.taxaSelecionada.numero,
        this.motivoCancelamentoTaxa
      ).then(
        (data) => {
          this.$root.$emit("alert:success", "Taxa cancelada com sucesso!");
          console.log(data);
        },
        (error) => {
          this.$root.$emit("alert:warn", "Não foi possível cancelar a Taxa!");
          console.log(error);
        }
      ).then(() => {
        this.displayCancelarTaxa = false;
        this.carregarTaxas();
        this.processando(false);
      });
    },
    exibirCancelarTaxa(taxa) {
      this.taxaSelecionada = taxa;
      this.motivoCancelamentoTaxa = '';
      this.displayCancelarTaxa = true;
    },
    async carregarTaxas() {
      return DeclaracaoService.findTaxas(
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key, this.filtroMes.key, ''
      ).then(
        (response) => {
          console.log(response);
          this.listTaxas = response.data;
        },
        (error) => {
          console.log(error);
          this.$root.$emit("alert:warn", error.response.data);
        })
    },
    hideItensDecbeneficio() {
      this.displayItensDecBeneficio = false;
    },
    escolhaPagamentoPix(idDamAgrupamento, tipoDam, dataVencimento) {
      this.idDamAgrupamento = idDamAgrupamento;
      this.tipoDam = tipoDam;
      this.dataVencimento = dataVencimento;
      this.showEscolhaPix = true;
    },
    compararDatasSemHora(data1, data2) {
      // Remove hora, minuto, segundo e milissegundo
      const d1 = new Date(data1.getFullYear(), data1.getMonth(), data1.getDate());
      const d2 = new Date(data2.getFullYear(), data2.getMonth(), data2.getDate());

      if (d1 > d2) return 1;    // data1 é depois de data2
      if (d1 < d2) return -1;   // data1 é antes de data2
      return 0;                 // datas são iguais (ignorando hora)
    },
    criarPagamentoPix() {
      this.processando(true);
      this.showEscolhaPix = false;

      //seta o vencimento como a data atual quando gera o qr code, pois não solicita data na tela
      let vencimento = new Date();

      if (this.travaDam >= 0 && this.compararDatasSemHora(vencimento, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
        return;
      }

      DeclaracaoService.criarPagamentoPix(
        this.idDamAgrupamento,
        this.idDeclaracaoSelecionada
      )
        .then(
          (response) => {
            console.log(response);
            this.pixGerado = response.data;
            this.optionsPix.data = this.pixGerado.qrCode;
            this.showPix = true;
          },
          (error) => {
            this.pixGerado = null;
            this.$root.$emit("alert:warn", error);
            console.log(error);
          }
        )
        .then(() => {
          this.showEscolhaPix = false;
          this.processando(false);
        });
    },
    carregarVencimentoBoleto(id, tipo, dataVencimento, tipoEmissao) {
      this.tipoEmissaoBoleto = tipoEmissao;
      this.showEscolhaPix = false;
      let d = dataVencimento.split("-");
      this.tipoDam = tipo;
      if (this.tipoDam === "A") {
        this.idDamAgrupamento = id;
      } else {
        this.idDecLancamentoSelecionado = id;
      }
      this.dataVencimento = new Date(d[0], d[1] - 1, d[2]);
      this.bloqueiaDataVencDam();
      this.displayVencBoleto = true;
    },
    hideVencBoleto() {
      this.displayVencBoleto = false;
      this.idDecLancamentoSelecionado = null;
      this.idDamAgrupamento = null;
    },
    imprimirBoleto() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      var novaData = new Date();
      console.log('aqui');
      console.log(this.dataVencimento);
      console.log(this.vencimentoMaximo);
      if (this.travaDam >= 0 && this.compararDatasSemHora(novaData, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
      } else if (this.travaDam >= 0 && this.compararDatasSemHora(this.dataVencimento, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
      } else {
        if (novaData > this.dataVencimento) {
          this.dataVencimento = novaData;
        }
        DeclaracaoService.atualizaVencimentoBoleto(
          this.tipoDam,
          this.idDamAgrupamento,
          this.idDeclaracaoSelecionada,
          this.dataVencimento
        )
          .then(
            (response) => {
              console.log(response);
              let idGerado = response.data;
              ReportService.imprimir("trb_dam_a5", [
                {
                  param: "RP_ID_CLIENTE",
                  string: this.currentUser.usuario.idCliente,
                },
                {
                  param: "P_CONTROLE_PARCELA",
                  string:
                    " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                    idGerado +
                    "')",
                },
              ]).then(
                (data) => {
                  console.log(data);
                },
                (error) => {
                  this.$root.$emit(
                    "alert:warn",
                    "Erro ao exibir a visualização!"
                  );
                  console.log(error);
                }
              );
            },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
              console.log(error);
            }
          )
          .then(() => {
            this.hideVencBoleto();
            this.hideBoletos();
            this.processando(false);
          });
      }
    },
    bloqueiaDataVencDam() {
      if (this.travaDam === 0 && !this.admin) {
        this.disableDataVencDam = true;
      } else if (this.travaDam === -1 && !this.admin) {
        this.disableDataVencDam = true;
        this.vencimentoMaximo = new Date();
        this.dataVencimento = new Date();
      } else if (this.travaDam === -2 && !this.admin) {
        this.disableDataVencDam = false;
      } else {
        this.disableDataVencDam = false;
      }
    },
    consultarPagamentoPix(idDamAgrupamento) {
      if (idDamAgrupamento) {
        this.processando(true);
        DeclaracaoService.consultarPagamentoPix(
          this.idDeclaracaoSelecionada,
          idDamAgrupamento
        )
          .then(
            (response) => {
              console.log(response);
              this.pesquisar();
              this.hideBoletos();
              this.showPix = false;
              this.$root.$emit("alert:info", response.data);
            },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    imprimirBoletoPix() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      console.log(this.tipoDam);
      var novaData = new Date();
      if (this.travaDam >= 0 && this.compararDatasSemHora(novaData, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
      } else if (this.travaDam >= 0 && this.compararDatasSemHora(this.dataVencimento, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
      } else {
        if (novaData > this.dataVencimento) {
          this.dataVencimento = novaData;
        }
        DeclaracaoService.atualizaVencimentoBoleto(
          this.tipoDam,
          this.idDamAgrupamento,
          this.idDeclaracaoSelecionada,
          this.dataVencimento
        )
          .then(
            (response) => {
              console.log(response);
              let idGerado = response.data;
              DeclaracaoService.criarPagamentoPixCp(
                idGerado,
                this.idDeclaracaoSelecionada
              )
                .then(
                  (response) => {
                    console.log(response);
                    this.pixGerado = response.data;
                    ReportService.imprimir("trb_dam_a5_pix", [
                      {
                        param: "RP_ID_CLIENTE",
                        string: this.currentUser.usuario.idCliente,
                      },
                      {
                        param: "QR_CODE",
                        string: this.pixGerado.qrCode,
                      },
                      {
                        param: "P_CONTROLE_PARCELA",
                        string:
                          " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                          idGerado +
                          "')",
                      },
                    ]).then(
                      (data) => {
                        console.log(data);
                      },
                      (error) => {
                        this.$root.$emit(
                          "alert:warn",
                          "Erro ao exibir a visualização!"
                        );
                        console.log(error);
                      }
                    );
                  },
                  (error) => {
                    this.pixGerado = null;
                    this.$root.$emit("alert:warn", error);
                    console.log(error);
                  }
                )
                .then(() => {
                  this.showEscolhaPix = false;
                  this.processando(false);
                });
            },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
              console.log(error);
            }
          )
          .then(() => {
            this.hideVencBoleto();
            this.hideBoletos();
            this.processando(false);
          });
      }
    },
    visualizarDanfse(idNota) {
      console.log(idNota);
      this.processando(true);

      NotaFiscalService.downloadDanfseHtml(idNota)
        .then(response => {
            const html = response.data;
            ReportService.openHtmlFromBytes(html);
        }).catch(error => {
            this.$root.$emit("alert:warn", "Erro ao efetuar o download da DANFSE!");
            console.error('Erro ao efetuar o download da DANFSE:', error);
        }).then(() => {
            this.processando(false);
        });
    },
    impressaoNota(idNotaNotaDeclaracao) {
      this.processando(true);
      let ret = idNotaNotaDeclaracao.split(";");
      let id = ret[1];
      if (ret[0] === "N") {
        let nomeRel = this.observacaoClienteNfse
          ? "NotaFiscalEletronicaObs"
          : "NotaFiscalEletronica";
        ReportService.imprimir(nomeRel, [
          {
            param: "where",
            string: " and nota_fiscal.id = '" + id + "' ",
          },
        ])
          .then(
            (data) => {
              console.log(data);
            },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        ReportService.imprimir("NotaFiscalAuxiliar", [
          {
            param: "where",
            string: " and nota.id = '" + id + "' ",
          },
        ])
          .then(
            () => { },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    showNotaDam() {
      this.showPesqNota = true;
    },
    getTotalIss(valor, abatimento, aliquota) {
      if (abatimento > valor) {
        abatimento = valor;
      }
      let val = ((valor - abatimento) * aliquota) / 100;
      if (!val) return "0,00";
      const valueString = val.toFixed(2).replace(".", ",");
      return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatted_string(pad, user_str, pad_pos) {
      if (typeof user_str === "undefined") return pad;
      if (pad_pos == "l") {
        return (pad + user_str).slice(-pad.length);
      } else {
        return (user_str + pad).substring(0, pad.length);
      }
    },
    async exportCSVDt1() {
      console.log(this.filtroAno.key);
      console.log(this.filtroMes.key);
      // this.$refs.dt1.exportCSV();
      await DeclaracaoService.getConsultaRelDecXlsComp(this.filtroAno.key, this.filtroMes.key, null, null).then(
        (response) => {
          response.data;
          this.sqlRelatorio = response.data;
        },
        (error) => {
          console.log(error);
        }
      );
      this.imprimirExcel();
    },
    imprimirExcel() {
      this.imprimirConsultaTipo('xls');
    },
    imprimirConsultaTipo(tipo) {
      this.processando(true);
      ReportService.imprimir("ConsultaDamXls", [
        {
          param: "P_CONSULTA",
          string: this.sqlRelatorio
        }
      ], tipo)
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao Imprimir!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    async imprimirNotificacao(idDeclaracao) {
      this.processando(true);

      try {
        let idCalculoParcelado = null;
        await DeclaracaoService.obterCalculoDeclaracao(idDeclaracao).then(
          (response) => {
            idCalculoParcelado = response.data;
          },
          (error) => {
            this.$root.$emit("alert:warn", error.response.data);
            return;
          }
        );
        await GpiService.imprimirNotificacao(this.currentUser.usuario.idCliente, idCalculoParcelado);
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const e = await error.response.data.text();
          try {
            const outer = JSON.parse(e);
            const inner = JSON.parse(outer.message);
            this.$root.$emit("alert:warn", inner.message || "Erro desconhecido");

          } catch (e) {
            this.$root.$emit("alert:warn", e);
          }
        } else {
          this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
        }
      }
      this.processando(false);
    },
  },
  computed: {
    isBloqueado() {
      return this.currentUser && this.currentUser.idBolBloquearSistema && this.currentUser.idBolBloquearSistema === 'S';
    },
    isAnaliseRetificacao: {
      get() {
        return this.currentUser.configuracao.idBolDecRetifAnalise === 'S';
      }
    },
    isPossuiTaxas: {
      get() {
        return this.listTaxas && this.listTaxas.length > 0;
      }
    },
    isPossuiTaxasDebito: {
      get() {
        return this.isPossuiTaxas && this.listTaxas.some(taxa => taxa.idBolDebito === 'S');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.white-line {
  color: white;
}

/deep/ .green-row {
  background-color: #28a745 !important;
}

/deep/ .red-row {
  background-color: #fd7272 !important;
}

textarea {
  width: 100%;
  border-radius: 12px;
}


.subtitle {
  margin-left: 55px;
  font-size: 14px;
  opacity: 0.8;
}

.custom-input {
  width: 80%;
  text-align: center;
  padding: 12px;
  border-radius: 12px;
  font-size: 16px;
  background-color: #f4f6f9;
  border: 1px solid #dcdcdc;
}
</style>